import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { Documents } from "src/app/components/account/models/Documents";
import { HandleError, HttpErrorHandler } from "src/app/shared/service/error.service";
import { environment } from "src/environments/environment.beta";

@Injectable({
    providedIn: 'root'
})
export class OfferService {

    private getOfertaElectricDocumentsByIdUrl = environment.devAppUrl + '/comparator/api/index.php?request=get-documents&oferta=';
    private getOfertaGasDocumentsByIdUrl = environment.devAppUrl + '/comparator/api/index.php?request=get-documents-gaz&oferta=';

    private readonly errorHandler: HandleError;

    constructor(private http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
        this.errorHandler = httpErrorHandler.createHandleError('PublicComparatorService');
    }

    getElectricOfferDocumentsByIdandType(offerId: string, documentType: string) {
        return this.http.get<Documents[]>(this.getOfertaElectricDocumentsByIdUrl + offerId +
            "&tip_document=" + documentType)
            .pipe(
                catchError(this.errorHandler('getOfferDocumentsById', null))
            );
    }

    getGasOfferDocumentsByIdandType(offerId: string, documentType: string) {
        return this.http.get<Documents[]>(this.getOfertaGasDocumentsByIdUrl + offerId +
            "&tip_document=" + documentType)
            .pipe(
                catchError(this.errorHandler('getGasOfferDocumentsByIdandType', null))
            );
    }

}
